export const exportTypeEnum = {
    GNR: 1,
    TEMPWORKERS: 2,
    DRIVERSAMPLIROLL: 3,
    DRIVERSTRUCKS: 4,
    SITESAMPLIROLL: 5,
    SITESTRUCKS: 6,
    MACHINES: 7,
    TOOLS: 8,
    RENTALS: 9,
    REPORTS: 10,
    SUBCONTRACTORS: 11,
    ACTIVITIES: 12,
};

export const csvDelimiterEnum = {
    COMMA: ',',
    SEMICOLON: ';',
    PIPE: '|',
};
